module.exports = {"530127001":"嵩阳街道","530127002":"杨桥街道","530127102":"小街镇","530127103":"杨林镇","530127104":"牛栏江镇","530127401":"嵩明杨林经济技术开发区","530127402":"云南省嵩明职业教育基地"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530127.json
// module id = 2683
// module chunks = 0